const shared = {
  servicesManagement: {
    fields: {
      priceMode: 'Price Mode',
      durationMode: 'Duration Mode',
      priceMin: 'Minimum price',
      priceMax: 'Maximum price',
      durationMin: 'Minimum duration',
      durationMax: 'Maximum duration',
    },
    valueMode: {
      fixed: 'Fixed',
      range: 'Range',
      onRequest: 'On request',
      priceFrom: 'From {{price}}',
    },
    planOrPackageLocked: 'Services with a price or duration range, or on request, cannot be included in membership plans or service packages.',
    validation: {
      priceRange: 'The maximum price must be greater than the minimum.',
      priceRangeMin: 'Enter a minimum price of zero or more.',
      durationRange: 'The maximum duration must be longer than the minimum.',
    },
  },
  customer: {
    appointments: {
      booking: {
        serviceInterestDraft: "Hi! I'm interested in the service {{serviceName}}.",
        priceToConfirm: 'Price to confirm',
      },
    },
  },
  managementAppointments: {
    book: {
      serviceDuration: 'Duration',
      servicePrice: 'Price',
      selectDuration: 'Choose a duration',
      validation: {
        durationRequired: 'Choose a duration for each service.',
        linePriceInvalid: 'Price cannot be negative.',
      },
    },
    setPrice: {
      action: 'Set price',
      title: 'Set price',
      price: 'Price',
      save: 'Save',
      outsideRange: 'This price is outside the service range ({{range}}). You can still set it.',
      error: 'The price could not be saved.',
    },
  },
};

export const servicePricingTranslationsEn = shared;

export const servicePricingTranslationsPt = {
  servicesManagement: {
    fields: {
      priceMode: 'Modo de preço',
      durationMode: 'Modo de duração',
      priceMin: 'Preço mínimo',
      priceMax: 'Preço máximo',
      durationMin: 'Duração mínima',
      durationMax: 'Duração máxima',
    },
    valueMode: {
      fixed: 'Fixo',
      range: 'Intervalo',
      onRequest: 'a consultar',
      priceFrom: 'A partir de {{price}}',
    },
    planOrPackageLocked: 'Serviços com preço ou duração em intervalo, ou a consultar, não podem ser incluídos em planos de assinatura ou pacotes de serviços.',
    validation: {
      priceRange: 'O preço máximo tem de ser superior ao mínimo.',
      priceRangeMin: 'Introduza um preço mínimo de zero ou mais.',
      durationRange: 'A duração máxima tem de ser superior à mínima.',
    },
  },
  customer: {
    appointments: {
      booking: {
        serviceInterestDraft: 'Olá! Tenho interesse no serviço {{serviceName}}.',
        priceToConfirm: 'Preço a confirmar',
      },
    },
  },
  managementAppointments: {
    book: {
      serviceDuration: 'Duração',
      servicePrice: 'Preço',
      selectDuration: 'Escolha uma duração',
      validation: {
        durationRequired: 'Escolha uma duração para cada serviço.',
        linePriceInvalid: 'O preço não pode ser negativo.',
      },
    },
    setPrice: {
      action: 'Definir preço',
      title: 'Definir preço',
      price: 'Preço',
      save: 'Guardar',
      outsideRange: 'Este preço está fora do intervalo do serviço ({{range}}). Mesmo assim pode defini-lo.',
      error: 'Não foi possível guardar o preço.',
    },
  },
};

export const servicePricingTranslationsEs = {
  servicesManagement: {
    fields: {
      priceMode: 'Modo de precio',
      durationMode: 'Modo de duración',
      priceMin: 'Precio mínimo',
      priceMax: 'Precio máximo',
      durationMin: 'Duración mínima',
      durationMax: 'Duración máxima',
    },
    valueMode: {
      fixed: 'Fijo',
      range: 'Rango',
      onRequest: 'a consultar',
      priceFrom: 'Desde {{price}}',
    },
    planOrPackageLocked: 'Los servicios con precio o duración en rango, o a consultar, no se pueden incluir en planes de membresía ni en paquetes de servicios.',
    validation: {
      priceRange: 'El precio máximo debe ser mayor que el mínimo.',
      priceRangeMin: 'Introduce un precio mínimo de cero o más.',
      durationRange: 'La duración máxima debe ser mayor que la mínima.',
    },
  },
  customer: {
    appointments: {
      booking: {
        serviceInterestDraft: '¡Hola! Me interesa el servicio {{serviceName}}.',
        priceToConfirm: 'Precio a confirmar',
      },
    },
  },
  managementAppointments: {
    book: {
      serviceDuration: 'Duración',
      servicePrice: 'Precio',
      selectDuration: 'Elige una duración',
      validation: {
        durationRequired: 'Elige una duración para cada servicio.',
        linePriceInvalid: 'El precio no puede ser negativo.',
      },
    },
    setPrice: {
      action: 'Definir precio',
      title: 'Definir precio',
      price: 'Precio',
      save: 'Guardar',
      outsideRange: 'Este precio está fuera del rango del servicio ({{range}}). Aun así puedes definirlo.',
      error: 'No se pudo guardar el precio.',
    },
  },
};
